export const MATERIAL_ICON_SVG: {icon: string, path: string}[] = [
  // EXAMPLE
  // {
  //   icon: 'bell-on',
  //   path: '../assets/icons/bell-on.svg',
  // },
];